import { put, takeLatest } from "redux-saga/effects";
import { GET_PLATFORM_META } from "@/constants/ActionTypes";
import { getPlatformMetaAPI } from "@/api/platformMeta.api";
import { IGetPlatformMetaAction } from "@/types/platformMeta.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import { showToast } from "@/actions/appStatus.action";
import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import { GET_PLATFORM_META_ERROR } from "@/constants/InterviewConstants";
import { updateAPIProgress } from "@/actions/progress.action";
import { call } from "./utils.saga";

function* getPlatformMeta({ payload }: IGetPlatformMetaAction) {
  try {
    yield put(updateAPIProgress(true));
    const { interviewSlug } = payload;
    const getPlatformMetaResponse = yield* call(
      getPlatformMetaAPI,
      interviewSlug,
    );
    yield put({
      type: `${GET_PLATFORM_META}_SUCCESS`,
      payload: {
        platformMeta: getPlatformMetaResponse.data.platform_meta,
      },
    });
  } catch (error) {
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_PLATFORM_META_ERROR.expectedErrorCodes,
      GET_PLATFORM_META_ERROR.defaultErrorMessage,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  } finally {
    yield put(updateAPIProgress(false));
  }
}

export default function* loadPlatformMetaSaga() {
  yield takeLatest(GET_PLATFORM_META, getPlatformMeta);
}
